import { classes } from '@/uiPrimitives/base/classes.helpers';
import { ResultMethods } from '../resultMethods.types';
import { accordionResultItem } from '../Results.css';
import { RenderedAccordionResult } from './accordionMethods.types';
import { ResultAccordionItem } from '../ResultAccordionItem.client';
import { box } from '@/uiPrimitives/layout/box';
import { indentSize } from '@/uiPrimitives/layout/indentSize.definitions';
import { textBlock } from '@/uiPrimitives/typography/text';
import { createElement } from 'react';
import { TitlePrefix } from '../../_renderers/TitlePrefix';
import { position } from '@/uiPrimitives/layout/position';

export const AccordionResultMethods: ResultMethods<RenderedAccordionResult> = {
	Render: ({ result, headingLevel }) => {
		return (
			<div
				className={classes(
					accordionResultItem,
					position({ position: 'relative' }),
				)}
			>
				<TitlePrefix titlePrefix={result.titlePrefix} />
				<ResultAccordionItem
					itemId={result.id}
					summarySlot={createElement(
						headingLevel,
						{ className: classes(textBlock({})) },
						result.title,
					)}
					titleText={result.titleText}
					className={classes(
						box({
							borderColor: 'negativeBlueEmphasis',
							borderWidth: '2px',
							borderStyle: 'solid',
							paddingInline: indentSize,
						}),
					)}
					closedClassName={classes(
						box({
							backgroundColor: 'negativeBlue',
						}),
					)}
				>
					{result.description}
				</ResultAccordionItem>
			</div>
		);
	},
};
